import React, { FunctionComponent, useEffect } from "react";
import { Unsubscribe, onSnapshot, getFirestore, collection, query, where, Query, DocumentData } from 'firebase/firestore';

import { getTranslations } from "../../features/translations/translationsUtils";
import { firebaseApp } from "../../services/firebase";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "antd";
import { selectCompany } from "../../features/company/companySlice";
import { importingUsers, importUsersSuccess } from "../../features/users/usersSlice";

import styles from './importUsersNotifications.module.scss';

const NOTIFICATION_USER_IMPORT_COLLECTION = 'companyImportUsersNotification';
const db = getFirestore(firebaseApp);

interface INotification {
  companyId: string;
  ready: boolean;
  type: 'importUsers';
  userCount: number;
  usersDone: number;
}

export const ImportUsersNotifications: FunctionComponent<{ companyId: string }> = ({ companyId }) => {
  const dispatch = useDispatch();
  const [notification, setNotification] = React.useState<INotification | null>(null);
  const [notificationId, setNotificationId] = React.useState<string | null>(null);
  const company = useSelector(selectCompany(notification?.companyId ?? ''));
  useEffect(() => {
    const collectionRef = collection(db, NOTIFICATION_USER_IMPORT_COLLECTION);
    let q: Query<DocumentData, DocumentData>;
    if (!companyId) {
      q = collectionRef;
    } else {
      q = query(
        collectionRef,
        where("companyId", "==", companyId)
      );
    }
    const unsubscribe: Unsubscribe = onSnapshot(
      q,
      { includeMetadataChanges: true },
      (querySnapshot) => {
        let lastNotification: INotification | null = null;
        let lastNotificationId: string | null = null;
        querySnapshot.forEach((doc) => {
          const data = doc.data() as INotification;
          if (data.ready) {
            return;
          }
          lastNotification = data;
          lastNotificationId = doc.id;
        });


        if (notificationId !== null && lastNotificationId === null) {
          setNotification({
            ...(notification ?? {} as INotification),
            ready: true,
            usersDone: notification?.userCount ?? 0,
          });
          setNotificationId(lastNotificationId);
          dispatch(importingUsers());
          return;
        }
        setNotification(lastNotification);
        setNotificationId(lastNotificationId);
        dispatch(importingUsers());
        if (lastNotification === null) {
          setNotificationId(null);
          dispatch(importUsersSuccess());
        }
      }
    );
    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, notificationId, companyId]);
  if (!notification) {
    return null;
  }
  const renderCloseButton = (notification: INotification) => {
    if (!notification.ready) {
      return null;
    }
    return <Button
      onClick={() => {
        setNotification(null);
        dispatch(importUsersSuccess());
      }}
      type="text">{getTranslations("USERS_IMPORT_IN_PROGRESS_CLOSE")}</Button>;
  };
  if (!company) {
    return null;
  }
  return <div className={styles.container}>
    <div>
      {getTranslations("USERS_IMPORT_IN_PROGRESS")}:
    </div>
    <div className={styles.companyName}>
      {company.name ?? ''}
    </div>
    <div>
      {notification.usersDone}/{notification.userCount} {getTranslations("USERS_IMPORT_IN_PROGRESS_USERS")} {renderCloseButton(notification)}
    </div>
  </div>;
}